"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var OpportunityService_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityService = void 0;
const typeorm_1 = require("typeorm/browser");
const data_ui_1 = require("../data-ui");
const layouts_1 = require("../data-ui/layouts");
const events_1 = require("../events");
const util_1 = require("../util");
const contact_profile_enum_1 = require("./contact-profile-enum");
const base_service_1 = require("./base-service");
const opportunity_1 = require("./opportunity");
const service_1 = require("./service");
let OpportunityService = OpportunityService_1 = class OpportunityService extends base_service_1.BaseService {
};
OpportunityService.EVENTS = (0, events_1.makeEventsForClass)(OpportunityService_1);
OpportunityService.SFID_PREFIX = 'a2o';
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ generated: true }),
    data_ui_1.DataUi.SearchField(),
    (0, typeorm_1.PrimaryColumn)('character varying', {
        nullable: false,
        length: 18,
        name: 'sfid',
        default: () => "gid_generate_sfid('a2o')",
    }),
    __metadata("design:type", String)
], OpportunityService.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
        name: 'api_id__c',
    }),
    __metadata("design:type", String)
], OpportunityService.prototype, "apiId", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('boolean', {
        name: 'legacy__c',
        default: false,
    }),
    __metadata("design:type", Boolean)
], OpportunityService.prototype, "legacy", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => opportunity_1.Opportunity),
    (0, typeorm_1.JoinColumn)({
        name: 'opportunity__c',
    }),
    __metadata("design:type", opportunity_1.Opportunity)
], OpportunityService.prototype, "opportunity", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => service_1.Service, (service) => service.opportunityServices, {
        nullable: false,
    }),
    (0, typeorm_1.JoinColumn)({
        name: 'overrides_service__c',
    }),
    __metadata("design:type", service_1.Service)
], OpportunityService.prototype, "overridesService", void 0);
__decorate([
    data_ui_1.DataUi.Override({ emptyToNull: true }),
    (0, typeorm_1.Column)('character varying', {
        name: 'description_en__c',
        length: 255,
        nullable: true,
    }),
    __metadata("design:type", String)
], OpportunityService.prototype, "descriptionEn", void 0);
__decorate([
    data_ui_1.DataUi.Override({ emptyToNull: true }),
    (0, typeorm_1.Column)('character varying', {
        name: 'description_de__c',
        length: 255,
        nullable: true,
    }),
    __metadata("design:type", String)
], OpportunityService.prototype, "descriptionDe", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Lagerplatz (m3)', emptyToNull: true }),
    (0, typeorm_1.Column)('double precision', {
        name: 'storage__c',
        nullable: true,
    }),
    __metadata("design:type", Number)
], OpportunityService.prototype, "storage", void 0);
__decorate([
    data_ui_1.DataUi.Override({ emptyToNull: true }),
    (0, typeorm_1.Column)('varchar', {
        name: 'planning_service__c',
        length: 255,
        nullable: true,
    }),
    __metadata("design:type", String)
], OpportunityService.prototype, "serviceType", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.EnumValuesFromPicklist('invoicetarget'),
    (0, typeorm_1.Column)('varchar', {
        name: 'invoicing_target__c',
        nullable: true,
        length: 255,
    }),
    __metadata("design:type", String)
], OpportunityService.prototype, "invoicingTarget", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: 'createddate',
    }),
    __metadata("design:type", Date)
], OpportunityService.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.UpdateDateColumn)({
        name: 'lastmodifieddate',
    }),
    __metadata("design:type", Date)
], OpportunityService.prototype, "updatedAt", void 0);
OpportunityService = OpportunityService_1 = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [contact_profile_enum_1.ContactProfileEnum.PRODUCT, contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER],
    }),
    data_ui_1.DataUi.Name({
        name: 'Opportunity Service',
        nameProperties: ['name'],
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Unique)(['opportunity', 'overridesService']),
    (0, typeorm_1.Entity)('opportunity_service__c', { schema: 'public', synchronize: true }),
    (0, util_1.InheritedColumnOptionsOverride)((columnOpts) => ({
        ...columnOpts,
        nullable: true,
    }))
], OpportunityService);
exports.OpportunityService = OpportunityService;
//# sourceMappingURL=opportunity-service.js.map